/**
 * Copyright (c) 2019, Tidepool Project
 *
 * This program is free software; you can redistribute it and/or modify it under
 * the terms of the associated License, which is identical to the BSD 2-Clause
 * License as published by the Open Source Initiative at opensource.org.
 *
 * This program is distributed in the hope that it will be useful, but WITHOUT
 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
 * FOR A PARTICULAR PURPOSE. See the License for more details.
 *
 * You should have received a copy of the License along with this program; if
 * not, you can obtain one from Tidepool Project at tidepool.org.
 */

/*
 *
 *	A set of helper functions for error and guardrail checking, also includes some time fixes and other commonly used functions
 *
 */

var utils = {};

utils.birthdayRange = function() {
	var lowerLimit = '1900-01-01';
	var today = new Date();
	var upperLimitYear = today.getFullYear();
	var upperLimitMonth = today.getMonth() + 1;
	if (upperLimitMonth < 10) {
		upperLimitMonth = '0' + upperLimitMonth;
	}
	var upperLimitDay = today.getDate();
	if (upperLimitDay < 10) {
		upperLimitDay = '0' + upperLimitDay;
	}
	var upperLimit = upperLimitYear + '-' + upperLimitMonth + '-' + upperLimitDay;
	return { min: lowerLimit, max: upperLimit };
};

utils.thresholdWarnings = function(value) {
	if (value < 54) {
		return { color: 'red', message: 'Threshold out of range. Please select a value between 54-150' };
	} else if (value < 70) {
		return { color: 'orange', message: 'This threshold is lower than recommended. Are you sure?' };
	} else if (value > 120) {
		return { color: 'orange', message: 'This threshold is higher than recommended. Are you sure?' };
	}
	return '';
};

utils.correctionRangeWarnings = function(value) {
	if (!value) {
		return '';
		// return { "color" : "red", "message" : "Empty value" };
	} else if (value < 60) {
		return { color: 'red', message: 'Correction target out of range. Please select a value between 60-180' };
	} else if (value < 70) {
		return { color: 'orange', message: 'This correction range is lower than recommended' };
	} else if (value > 120 && value < 180) {
		return { color: 'orange', message: 'This correction range is higher than recommended' };
	} else if (value >= 180) {
		return { color: 'red', message: 'Correction target out of range. Please select a value between 60-180' };
	}
	return '';
};

utils.deliveryLimitsWarnings = function(value, type) {
	if (type === 'basal') {
		if (value === 0) {
			return { color: 'orange', message: 'A setting of 0 means that you will not receive a basal' };
		} else if (value > 30) {
			return { color: 'red', message: 'Basal limit out of range. Please select a value between 0-30' };
		}
	} else if (type === 'bolus') {
		if (value === 0) {
			return { color: 'orange', message: 'A setting of 0 means that you will not receive a bolus' };
		} else if (value > 20 && value < 30) {
			return { color: 'orange', message: 'This bolus limit is higher than recommended' };
		} else if (value >= 30) {
			return { color: 'red', message: 'Bolus limit out of range. Please select a value between 0-30' };
		}
	}
	return '';
};

utils.getColumnIdentifier = function(tabletype) {
	if (tabletype === 'basal') {
		return 'Basal rates values (in U/hr)';
	} else if (tabletype === 'bolus') {
		return '1 U of insulin covers (g/U)';
	} else if (tabletype === 'sensitivity') {
		return '1 U of insulin decreases BG by';
	} else {
		return 'Values';
	}
};

utils.getAdditionalButtonName = function(tabletype) {
	if (tabletype === 'basal') {
		return 'Add an additional basal rate';
	} else if (tabletype === 'bolus') {
		return 'Add an additional carb ratio';
	} else if (tabletype === 'sensitivity') {
		return 'Add an additional insulin sensitivity factor';
	} else {
		return 'Add an additional value';
	}
};

utils.timeValuePickerWarnings = function(value, tabletype) {
	if (tabletype === 'basal') {
		if (!value) {
			return '';
			// return { "color" : "red", "message" : "Empty value" };
		} else if (value < 0.025) {
			return { color: 'orange', message: 'A setting of 0 means that you will not receive a basal' };
		} else if (value >= 30 && value < 35) {
			return { color: 'orange', message: 'This basal is higher than recommended' };
		} else if (value >= 35) {
			return { color: 'red', message: 'Basal rate out of range. Please select a value between 0-35' };
		}
	} else if (tabletype === 'bolus') {
		if (!value) {
			return '';
			// return { "color" : "red", "message" : "Empty value" };
		} else if (value <= 3) {
			return { color: 'orange', message: 'This bolus is lower than recommended' };
		} else if (value >= 28 && value < 150) {
			return { color: 'orange', message: 'This bolus is higher than recommended' };
		} else if (value >= 150) {
			return { color: 'red', message: 'Insulin-to-carb ratio out of range. Please select a value between 1-150' };
		}
	} else if (tabletype === 'sensitivity') {
		if (!value) {
			return '';
			// return { "color" : "red", "message" : "Empty value" };
		} else if (value < 10) {
			return { color: 'red', message: 'Sensitivity factor out of range. Please select a value between 10-500' };
		} else if (value <= 15) {
			return { color: 'orange', message: 'This sensitivity is lower than recommended' };
		} else if (value >= 400 && value < 500) {
			return { color: 'orange', message: 'This sensitivity is higher than recommended' };
		} else if (value >= 500) {
			return { color: 'red', message: 'Sensitivity factor out of range. Please select a value between 10-500' };
		}
	}
	return '';
};

utils.barriers = function(tabletype) {
	if (tabletype === 'basal') {
		return { min: '0', max: '35', step: '0.025' };
	} else if (tabletype === 'bolus') {
		return { min: '1', max: '150', step: '1' };
	} else if (tabletype === 'sensitivity') {
		return { min: '10', max: '500', step: '1' };
	} else if (tabletype === 'cRange') {
		return { min: '60', max: '180', step: '1' };
	} else if (tabletype === 'threshold') {
		return { min: '54', max: '150', step: '1' };
	} else if (tabletype === 'maxBasal') {
		return { min: '0', max: '30', step: '0.25' };
	} else if (tabletype === 'maxBolus') {
		return { min: '0', max: '30', step: '1' };
	} else {
		return '';
	}
};

utils.unitsHelper = function(tabletype) {
	if (tabletype === 'basal') {
		return 'U/hr';
	} else if (tabletype === 'bolus') {
		return 'g/U';
	} else if (tabletype === 'sensitivity') {
		return 'mg/dL';
	}
	return '';
};

utils.getInitialValue = function(tabletype) {
	if (tabletype === 'basal') {
		return 0.05;
	} else if (tabletype === 'bolus') {
		return 10;
	} else if (tabletype === 'sensitivity') {
		return 100;
	}
	return 0;
};

utils.helperTextPicker = function(touched, errors, warningText) {
	if (touched) {
		if (Boolean(warningText)) {
			return warningText.message;
		} else {
			return errors;
		}
	} else {
		return warningText.message;
	}
};

utils.getLastValue = function(values, tabletype) {
	if (tabletype !== 'cRange') {
		return values[values.length - 1].val;
	} else {
		return { lowerLimit: values[values.length - 1].lowerLimit, upperLimit: values[values.length - 1].upperLimit };
	}
};

utils.compare = function(item1, item2) {
	if (parseInt(item1.time.slice(0, 2)) > parseInt(item2.time.slice(0, 2))) return 1;
	if (parseInt(item2.time.slice(0, 2)) > parseInt(item1.time.slice(0, 2))) return -1;
	if (parseInt(item1.time.slice(3, 5)) > parseInt(item2.time.slice(3, 5))) return 1;
	if (parseInt(item2.time.slice(3, 5)) > parseInt(item1.time.slice(3, 5))) return -1;
	return 1;
};

function getMonth(month) {
	var Months = [
		'January',
		'February',
		'March',
		'April',
		'May',
		'June',
		'July',
		'August',
		'September',
		'October',
		'November',
		'December'
	];
	return Months[month - 1];
}

utils.birthdayFix = function(bday) {
	var year = bday.slice(0, 4);
	var month = getMonth(parseInt(bday.slice(5, 7)));
	var day = bday.slice(8, 10);

	return month + ' ' + day + ', ' + year;
};

utils.fixTime = function(time) {
	var suffix = parseInt(time.slice(0, 2)) >= 12 ? 'PM' : 'AM';
	var hours = (((parseInt(time.slice(0, 2)) + 11) % 12) + 1).toString();
	var minutes = time.slice(3, 5);
	return hours + ':' + minutes + ' ' + suffix;
};

utils.initialTherapySettingLanguage = function(therapy, name) {
	if (therapy === 'tps') {
		return name + ' will tranfer their standard pump settings on initial download or training of Tidepool loop';
	}
	if (therapy === 'cpt') {
		return name + ' will determind settings with a CPT';
	}
};

module.exports = utils;
